import {DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../misc/SmoothActionBar";
import {AutoComplete} from "../openings/AutoComplete";
import {api} from "../../../../api/API";
import {useState} from "react";
import {Project, projectLabel} from "../../../../api/Projects";
import {useProjectId} from "../ProjectName";
import {useAsyncAction} from "nate-react-api-helpers";
import {useSyncedRef} from "../../../../misc/SyncedRef";

export function CopyKeyingFromProject(props: {
    onDone(): void;
    onCancel(): void;
}) {
    const [value, setValue] = useState<Project>();
    const project = useProjectId();
    const onDoneRef = useSyncedRef(props.onDone);

    const copy = useAsyncAction(async (input: {
        project: number;
        from: number;
    }) => {
        await api.keying2.copyFromProject(input);
        onDoneRef.current();
    }, []);

    return (
        <Dialog2 open onClose={props.onCancel}>
            <DialogTitle>
                Copy Keying from Project
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Add the designations and shortcodes from the selected project. Existing designations and shortcodes are kept.
                </DialogContentText>

                <div style={{height: 10}} />

                <AutoComplete<Project>
                    fullWidth
                    search={async search => {
                        const rs = await api.projects.list({search: search, offset: 0, stage: "in-progress"});
                        return rs.data.filter(d => d.id !== project);
                    }}
                    value={value}
                    equals={(a, b) => a.id === b.id}
                    makeLabel={projectLabel}
                    onSelect={setValue} />
            </DialogContent>
            <SmoothActionBar
                loading={copy.loading}
                error={copy.error}
                onCancel={props.onCancel}
                submitDisabled={!value}
                actionName="Copy"
                onSubmit={() => {
                    copy.callback({
                        project: project,
                        from: value?.id || 0,
                    });
                }}
            />
        </Dialog2>
    )
}
